<template>
  <el-container>
    <el-header class="visitor_header">
      <div>
        <p>访客预约</p>
      </div>
    </el-header>
    <el-main class="visitor_main" style="min-height:600px;">
      <el-row>
        <a :href="jxsqurl">
          <button class="buttenStyle">进校申请</button>
        </a>
      </el-row>

      <div v-if="total>0">
        <el-collapse v-model="activeName" accordion>
          <div v-for="(fkform,index) in fkyyxxList" :key="fkform.id">
            <el-collapse-item :name="index">
              <template slot="title">
                <p style="width : 60%">{{fkform.deptname}}-{{fkform.fwdxname}}</p>
                <p :style="getTitleStyle(fkform.state)">{{isTG(fkform.state)}}</p>
              </template>

              <table class="table">
                <tr class="tr_color">
                  <td class="td_name">申请时间</td>
                  <td class="td_key">{{fkform.createdate | formatDate}}</td>
                </tr>
                <tr class="tr_color" v-if="fkform.state == -1">
                  <td class="td_name">未通过原因</td>
                  <td class="td_key">{{fkform.btyyy}}</td>
                </tr>
                <tr class="tr_color">
                  <td class="td_name">进校事由</td>
                  <td class="td_key">{{fkform.jxsy}}</td>
                </tr>
                <tr class="tr_color">
                  <td class="td_name">进校日期</td>
                  <td class="td_key">{{fkform.jxrqfrom | formatDate}}</td>
                </tr>
                <tr class="tr_color">
                  <td class="td_name">离校日期</td>
                  <td class="td_key">{{fkform.jxrqto | formatDate}}</td>
                </tr>
                <tr class="tr_color">
                  <td class="td_name">访客信息</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <template>
                      <el-table :data="fkform.fklist" style="width: 100%" :show-header="false">
                        <el-table-column prop="name">
                        </el-table-column>
                        <el-table-column prop="phone" width="180">
                        </el-table-column>
                      </el-table>
                    </template>
                  </td>
                </tr>
              </table>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
      <div v-else>
        <el-row>
          <p>暂无申请数据</p>
        </el-row>
      </div>
    </el-main>

    <el-footer class="visitor_footer">
      <div class="div_pagination" v-if="total>10">
        <el-pagination
            small
            layout="prev, pager, next"
            :total="total"
            :page-size="queryInfo.pageSize"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <el-row>
        <el-button type="" @click="loginClick" class="inputwidth">重新登录</el-button>
      </el-row>
      <el-row>
        <div class="userid">
          <i class="el-icon-user"> : {{userid}}</i>
        </div>
      </el-row>
    </el-footer>
    <div class="Verify_footer">
      Copyright@山东青年政治学院
    </div>
  </el-container>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  data() {
    return {
      applys: [],
      userid: "",
      activeName: '1',
      // 加密密钥（必须与后端一致）
      secretKey: "sdyu2024visitors",
      // ========== 新增：loginToken变量，用于存储登录token ==========
      loginToken: "",
      queryInfo: {
        query: 0,
        pageNum: 1,
        pageSize: 10,
      },
      fkyyxxList: [],
      total: 0,
      jxsqurl: "",
      fontweight: "bold",
      textalign: "right",
    }
  },
  created() {
    this.getUser();
    this.getApplyList();
  },
  methods: {
    // 加密手机号
    encryptPhone(phone) {
      if (!phone || phone === 0) return '';

      // 确保 phone 是纯数字字符串，没有引号
      const cleanPhone = phone.toString().replace(/["']/g, '').trim();

      const key = CryptoJS.enc.Utf8.parse(this.secretKey);
      const encrypted = CryptoJS.AES.encrypt(cleanPhone, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });

      return encrypted.toString();
    },

    // ========== 修改：获取用户数据，同时获取token ==========
    getUser() {
      var user = sessionStorage.getItem("user");
      var token = sessionStorage.getItem("login_token");

      // 如果 user 是 JSON 对象，提取手机号
      let tel = user;
      if (user && user.startsWith('{')) {
        try {
          const userObj = JSON.parse(user);
          tel = userObj.phone || userObj.mobile || userObj.userid;
        } catch(e) {
          console.error("解析失败", e);
        }
      }

      // 清理手机号
      if (tel) {
        tel = tel.toString().replace(/["']/g, '').trim();
      }

      var urljson = sessionStorage.getItem("url");
      var url = urljson ? JSON.parse(urljson) : "";

      this.jxsqurl = url;
      this.userid = tel;
      this.queryInfo.query = tel;
      // ========== 新增：保存token到data中 ==========
      this.loginToken = token;
      console.log("获取到的token:", token);
    },

    // ========== 修改：获取申请信息列表，携带token ==========
    async getApplyList() {
      // 检查是否有token
      if (!this.loginToken) {
        console.log("未登录，请先登录");
        this.$message.error("请先登录");
        this.loginClick();
        return;
      }

      // 加密手机号后发送
      const encryptedPhone = this.encryptPhone(this.queryInfo.query);

      try {
        const { data: res } = await this.$http.get("fkyyxx", {
          params: {
            query: encryptedPhone,
            pageNum: this.queryInfo.pageNum,
            pageSize: this.queryInfo.pageSize,
            // ========== 新增：携带token ==========
            token: this.loginToken
          }
        });

        // ========== 新增：处理未授权响应 ==========
        if (res.code === 401) {
          this.$message.error(res.message || "请重新登录");
          this.loginClick();
          return;
        }

        if (res.code === 403) {
          this.$message.error(res.message || "无权访问");
          return;
        }

        this.fkyyxxList = res.data || [];
        this.total = res.numbers || 0;
      } catch (error) {
        console.error("获取申请列表失败:", error);
        this.$message.error("获取数据失败");
      }
    },

    // 分页页码切换
    handleCurrentChange(pageNum) {
      this.queryInfo.pageNum = pageNum;
      this.getApplyList();
    },

    isTG(state) {
      if (state > 0) {
        return "已通过";
      } else if (state == 0) {
        return "审批中";
      } else {
        return "未通过";
      }
    },

    getTitleStyle(state) {
      var textcolor = "#909399";
      if (state == -1) {
        textcolor = "#F56C6C";
      }
      if (state > 0) {
        textcolor = "#006934";
      }
      return { fontWeight: this.fontweight, textAlign: this.textalign, color: textcolor, width: '35%' };
    },

    loginClick() {
      window.sessionStorage.clear();
      this.$router.push("/login");
    },
  },
  filters: {
    formatDate: function(value) {
      if (!value) return '';
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + MM + '-' + d;
    }
  }
}
</script>

<style scoped>
.td_name {
  width: 40%;
  color: #909399;
}
.td_key {
  color: #606266;
  margin: 5px 0px 0px 0px;
}
.table {
  width: 100%;
  margin: 10px 0px 0px 0px;
}
.tr_color:hover {
  background-color: #eee;
}
.div_pagination {
  text-align: center;
}
.inputwidth {
  width: 100%;
}
.userid {
  padding: 5px 0px 5px 0px;
}
.Verify_footer {
  background-color: #006934;
  color: #ffffff;
  text-align: center;
  font-size: 75%;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 20px;
  margin: 0px;
}
.visitor_footer {
  position: fixed;
  bottom: 30px;
  text-align: center;
  width: 100%;
}
.buttenStyle {
  color: #006934;
  background-color: #E7F0EB;
  border: 1px solid #006934;
  border-radius: 4px;
  height: 40px;
  width: 100%;
}
.buttenStyle:focus {
  background: #006934;
  border: 1px solid #006934;
  color: #ffffff;
}
.buttenStyle:hover {
  background: #006934;
  border: 1px solid #006934;
  color: #ffffff;
}
.visitor_header {
  background-color: #006934;
  text-align: center;
  color: #ffffff;
  font-size: 120%;
}
</style>